export default {
  index(params = {}, config = {}) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/', { ...config, params: params });
  },

  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/' + id);
  },

  update(invoicedescriptiontemplate) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/' + invoicedescriptiontemplate.id, { invoicedescriptiontemplate });
  },

  store(invoicedescriptiontemplate) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/', { invoicedescriptiontemplate });
  },

  delete(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/' + id);
  },

  calculate(descriptionTemplateData) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoice-description-templates/calculate', {
      ...descriptionTemplateData,
    });
  },
};
